import React from 'react';
import PropTypes from 'prop-types';
import TableWithLoading from '../TableWithLoading';

/**
 * Enhanced table component that wraps any table with loading and empty states
 */
function EnhancedTable({
                           TableComponent,
                           isLoading = false,
                           data = [],
                           loadingMessage,
                           noDataMessage,
                           ...tableProps
                       }) {
    return (
        <TableWithLoading
            isLoading={isLoading}
            data={data}
            loadingMessage={loadingMessage}
            noDataMessage={noDataMessage}
        >
            <TableComponent
                {...tableProps}
                rows={data}
            />
        </TableWithLoading>
    );
}

EnhancedTable.propTypes = {
    TableComponent: PropTypes.elementType.isRequired,
    isLoading: PropTypes.bool,
    data: PropTypes.array,
    loadingMessage: PropTypes.string,
    noDataMessage: PropTypes.string,
};

export default EnhancedTable;
